import React, { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { FaFileSignature } from "react-icons/fa";
import EditformsHeaderjournal from './editformsHeaderjournal';
import Showdetailjournal from '../../../form01/components/showdetailjournal';
import Modal from 'react-bootstrap/Modal';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Detailrevision from './detailrevision';
import { createRevision_Duplicate, saveNoterevise } from './service/serviceCreaterevision';
import Swal from 'sweetalert2';
import FetchApi from '../../../customhooks/functionFetchApi';
import { ToastContainer, toast } from 'react-toastify';

function Actionrevision({ id, actionState, codetds, revision }) {
    const FetchApis = new FetchApi();
    const [journallist, setJournallist] = useState([])
    let revisionNew = parseInt(revision) + 1;
    const emcode = sessionStorage.getItem('EmCode');
    const [fullscreen, setFullscreen] = useState(true);
    const [show, setShow] = useState(false);
    const [opennote, setOpennote] = useState(false);
    const [datanote, setDatanote] = useState({ detaillist: '', noteById: '', journalcode: '', revision: '', createdate: '' })

    function handleShow(values) {
        setShow(values);
    }

    const onClickNewRevision = () => {
        setOpennote(true);
    }

    function saveNoteRevise() {
        setOpennote(false);

        var datetiemnow=datetimenow();

        var datanotelist = {
            detaillist:datanote.detaillist,
            noteById:emcode,
            journalcode:codetds,
            revision:revisionNew,
            createdate:datetiemnow
        }

        

        Swal.fire({
            title: "แจ้งเตือน",
            text: "คุณแน่ใจที่จะสร้างเอกสาร ใช่หรือไม่ ! ",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "ใช่",
            cancelButtonText: 'ยกเลิก'
        }).then((result) => {

            if (result.isConfirmed) {

                var dataobject = {
                    codetds: codetds,
                    revision: revisionNew.toString()
                }
                
                FetchApis.FethcPost(`/journal/getcheckRevisionJournal`, dataobject).then((res) => {
                    if (res.status == 200) {
                        if (res.data[0].countId == 0) {

                            // console.log(res.data[0])
                            toast.success('บันทึกเรียบร้อยแล้ว', {
                                position: "top-right",
                                autoClose: 1700,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                                // transition: Bounce,
                              });

                            createRevision_Duplicate(id);
                            saveNoterevise(datanotelist);

                        }
                        else {

                            Swal.fire({
                                title: "แจ้งเตือน!",
                                text: `เอกสารนี้มี revision ${revisionNew.toString()} แล้ว กรุณาตรวจสอบอีกครั้ง`,
                                icon: "warning"
                            });
                        }

                    }
                    else {
                        console.log(res)
                    }

                })



            }
        });

    }

    function hendleChange(e) {
        var input = e.target.value;
        const cleanInput = input.replace(/[^a-zA-Z0-9ก-๙\s()#/.%:";,=\-&@$<>+*/?!]/g, "");
        setDatanote({ ...datanote, detaillist: cleanInput });
        // setDataHeader({ ...dataHeader, [e.target.name]: cleanInput });

    }

 const datetimenow = () => {
        const now = new Date();

        // แปลงเป็นเวลาไทย
        const options = {
            timeZone: "Asia/Bangkok",
        };
        const thaiDate = new Date(now.toLocaleString("en-US", options));

        // แยกค่าต่างๆ ออกมาเป็นตัวเลข
        const year = thaiDate.getFullYear() + 543; // แปลงเป็น พ.ศ.
        const month = String(thaiDate.getMonth() + 1).padStart(2, "0");
        const day = String(thaiDate.getDate()).padStart(2, "0");
        const hour = String(thaiDate.getHours()).padStart(2, "0");
        const minute = String(thaiDate.getMinutes()).padStart(2, "0");
        const second = String(thaiDate.getSeconds()).padStart(2, "0");

        // รูปแบบวันที่และเวลา (เช่น 05/11/2568 14:32:10)
        var timestampsnow = year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
        return timestampsnow
    }


    return (
        <div>
            <Button size='sm'
                onClick={() => handleShow(true)} variant='warning' disabled={actionState}><FaFileSignature /> สร้าง revision</Button>

            <Modal
                show={show}
                onHide={() => setShow(false)}
                // size="lg"
                fullscreen={fullscreen}
                dialogClassName="modal-90w"
                aria-labelledby="example-custom-modal-styling-title"
            >
                <Modal.Header >

                    <div style={{ width: '20%', fontSize: 18 }}>รายละเอียดเอกสาร</div>
                    <div className='end-flex-row '>
                        <Button size='sm' variant="success" style={{ marginRight: 10 }} onClick={() => onClickNewRevision()}>สร้าง revision</Button>
                        <Button variant="secondary" size='sm' onClick={() => setShow(false)}>Close</Button>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Detailrevision jourId={id} />
                </Modal.Body>

            </Modal>



            {/* ส่วนของ note ก่อน revise */}
            <Modal
                show={opennote}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        คำธิบาย revise เอกสาร
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <textarea value={datanote.detaillist} onChange={(e) => hendleChange(e)} style={{width:'100%',height:100}}/>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => saveNoteRevise()} variant="success">บันทึกสร้าง</Button>
                    <Button onClick={() => setOpennote(false)}>ยกเลิก</Button>
                </Modal.Footer>
            </Modal>


        </div>
    )
}

export default Actionrevision